let hasVersionMismatch = false;
let beforeVersionReload: () => void = () => undefined;

export function setVersionMismatch(enabled: boolean) {
  hasVersionMismatch = enabled;
}

export function setBeforeVersionReload(callback: () => void): void {
  beforeVersionReload = callback;
}

export function shouldForceReload(pathname: string): boolean {
  const shouldReload = hasVersionMismatch && Boolean(pathname);

  if (shouldReload) {
    beforeVersionReload();
  }

  return shouldReload;
}
